export default __webpack_public_path__ + "static/itnick-d5af42d4d412b432266107a41af4dd24.jpg";